import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const blue = "#08306b";
const yellow = "#fffd33";

function MessagesPage() {
  const [messages, setMessages] = useState([]);
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const navigate = useNavigate();
  const handleBack = () => navigate("/admin");

  const API = (process.env.REACT_APP_API_URL || "").replace(/\/$/, ""); // e.g. http://vision.org.gr/api

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);
        setErr("");
        const res = await fetch(`${API}/messages`);
        if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
        const data = await res.json();
        setMessages(data);
      } catch (e) {
        console.error("Failed to load messages:", e);
        setErr("Failed to load messages.");
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [API]);

  const handleDelete = async (id) => {
    const msgToDelete = messages.find(m => m.id === id);
    const confirmDelete = window.confirm(
      `Are you sure you want to delete the message from "${msgToDelete?.name || id}"?`
    );
    if (!confirmDelete) return;

    try {
      const res = await fetch(`${API}/messages/${id}`, { method: "DELETE" });
      if (!res.ok) {
        const text = await res.text();
        throw new Error(text || `Failed with ${res.status}`);
      }
      setMessages(prev => prev.filter(m => m.id !== id));
      if (selectedMessage?.id === id) setSelectedMessage(null);
    } catch (e) {
      console.error("Delete failed:", e);
      alert("Failed to delete message.");
    }
  };

  const fmt = (ts) => {
    try {
      return new Date(ts).toLocaleString();
    } catch {
      return ts;
    }
  };

  return (
    <div style={styles.container}>
      <button style={styles.back} onClick={handleBack}>←</button>
      <h1 style={styles.title}>Messages</h1>

      {loading && <p>Loading…</p>}
      {err && <p style={{ color: "tomato" }}>{err}</p>}

      <div style={styles.listContainer}>
        {messages.map((msg) => (
          <div key={msg.id} style={styles.messageRow}>
            <span
              onClick={() => setSelectedMessage(msg)}
              style={styles.messageText}
              title="Click to view"
            >
              {msg.name}
            </span>
            <span style={styles.date}>{fmt(msg.created_at)}</span>
            <button
              style={styles.deleteButton}
              onClick={() => handleDelete(msg.id)}
              title="Delete"
            >
              ✕
            </button>
          </div>
        ))}
        {(!loading && !err && messages.length === 0) && (
          <p style={{ marginTop: 20 }}>No messages yet.</p>
        )}
      </div>

      {selectedMessage && (
        <div style={styles.messageDetail}>
          <button
            style={styles.closeButton}
            onClick={() => setSelectedMessage(null)}
          >
            Close
          </button>
          <h2>{selectedMessage.name}</h2>
          <p><strong>Email:</strong> {selectedMessage.email}</p>
          <p><strong>Message:</strong><br />{selectedMessage.message}</p>
          <p style={{ marginTop: 10, opacity: 0.8 }}>
            <strong>Received:</strong> {fmt(selectedMessage.created_at)}
          </p>
        </div>
      )}
    </div>
  );
}

const styles = {
  container: {
    minHeight: "100vh",
    backgroundColor: blue,
    color: "#ffffff",
    padding: "40px 20px",
    fontFamily: "'Segoe UI', sans-serif",
  },
  title: {
    fontSize: "38px",
    marginBottom: "30px",
    fontWeight: "700",
    textAlign: "center",
  },
  listContainer: {
    maxWidth: "700px",
    margin: "0 auto 40px",
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  messageRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: yellow,
    color: blue,
    padding: "12px 16px",
    borderRadius: "10px",
    fontWeight: "bold",
    gap: "10px",
  },
  messageText: {
    flex: 1,
    cursor: "pointer",
    textAlign: "left",
  },
  date: {
    fontStyle: "italic",
    fontSize: "14px",
  },
  deleteButton: {
    backgroundColor: "transparent",
    border: "none",
    color: blue,
    fontSize: "18px",
    fontWeight: "bold",
    cursor: "pointer",
  },
  messageDetail: {
    backgroundColor: "#ffffff22",
    padding: "20px",
    borderRadius: "12px",
    maxWidth: "700px",
    margin: "0 auto",
    textAlign: "left",
    position: "relative",
  },
  closeButton: {
    position: "absolute",
    top: "10px",
    right: "10px",
    backgroundColor: yellow,
    color: blue,
    border: "none",
    borderRadius: "8px",
    padding: "5px 10px",
    cursor: "pointer",
    fontWeight: "bold",
  },
  back: {
    alignSelf: "flex-start",
    fontSize: "24px",
    background: "none",
    border: "none",
    color: yellow,
    cursor: "pointer",
    marginBottom: "20px",
  },
};

export default MessagesPage;